import React, { useRef } from "react";
import classNames from "classnames";
import Lightbox, { ControllerRef } from "yet-another-react-lightbox";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import GalleryNextIcon from "@components/Svg/GalleryNextIcon";
import GalleryPrevIcon from "@components/Svg/GalleryPrevIcon";
import { SpriteIcon } from "@shared/ui/SpriteIcon";
import { CustomLightboxProps } from "./types";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/counter.css";
import classes from "./custom-lightbox.module.scss";

export const CustomLightbox = ({
    open,
    close,
    index,
    slides,
    onViewChange
}: CustomLightboxProps) => {
    const zoomRef = useRef(null);
    const controllerRef = useRef<ControllerRef | null>(null);

    const updateIndex = () => {
        const currentIndex = controllerRef.current?.getLightboxState().currentIndex;
        if (currentIndex !== undefined) {
            onViewChange(currentIndex);
        }
    };

    const handleClose = () => {
        updateIndex();
        close();
    };

    const handlePrev = () => {
        controllerRef.current?.prev();
    };

    const handleNext = () => {
        controllerRef.current?.next();
    };

    return (
        <Lightbox
            open={open}
            close={handleClose}
            index={index}
            slides={slides}
            controller={{
                ref: controllerRef,
                closeOnBackdropClick: true
            }}
            className={classes.lightbox}
            on={{
                view: ({ index }) => onViewChange(index)
            }}
            plugins={[Thumbnails, Counter, Zoom]}
            animation={{
                fade: 200,
                swipe: 300,
                zoom: 1000,
                easing: {
                    fade: "ease-in-out",
                    swipe: "ease-in-out"
                }
            }}
            zoom={{
                ref: zoomRef,
                scrollToZoom: true,
                maxZoomPixelRatio: 3,
                zoomInMultiplier: 1.01,
                wheelZoomDistanceFactor: 100,
                pinchZoomDistanceFactor: 50,
                doubleClickMaxStops: 1
            }}
            thumbnails={{
                width: 140,
                height: 100,
                padding: 0,
                borderRadius: 6,
                gap: 16,
                border: 0,
                imageFit: "cover"
            }}
            render={{
                buttonPrev: () => (
                    <div
                        className={classNames(
                            classes.lightbox__control,
                            classes["lightbox__control--prev"]
                        )}
                        onClick={handlePrev}
                    >
                        <GalleryPrevIcon />
                    </div>
                ),
                buttonNext: () => (
                    <div
                        className={classNames(
                            classes.lightbox__control,
                            classes["lightbox__control--next"]
                        )}
                        onClick={handleNext}
                    >
                        <GalleryNextIcon />
                    </div>
                ),
                buttonZoom: () => null,
                iconError: () => (
                    <SpriteIcon width={40} height={40} section={"gallery"} name={"empty-photo"} />
                )
            }}
        />
    );
};